import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import Login from './components/Login';
import PanelControl from './components/PanelControl';
import RutaProtegida from './components/RutaProtegida';
import AdminProtectedRoute from './components/admin/AdminProtectedRoute';
import AdminLogin from './pages/admin/AdminLogin';
import EmpresasPage from './pages/admin/EmpresasPage';
import EmpresaDetailPage from './pages/admin/EmpresaDetailPage';
import PlanesPage from './pages/admin/PlanesPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AdminAuthProvider>
          <div className="App">
            <Routes>
              {/* Rutas de la app principal */}
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <RutaProtegida>
                    <PanelControl />
                  </RutaProtegida>
                }
              />

              {/* Rutas del panel de superadmin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/empresas"
                element={<AdminProtectedRoute><EmpresasPage /></AdminProtectedRoute>}
              />
              <Route
                path="/admin/empresas/:id"
                element={<AdminProtectedRoute><EmpresaDetailPage /></AdminProtectedRoute>}
              />
              <Route
                path="/admin/planes"
                element={<AdminProtectedRoute><PlanesPage /></AdminProtectedRoute>}
              />
              <Route path="/admin" element={<Navigate to="/admin/empresas" replace />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </AdminAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
